<style src="./EventInfo.scss" lang="scss" scoped></style>
<template>
  <section class="event-info">
    <div class="client-name">
      <h2>{{ eventInfo.client.shortName }}</h2>
    </div>

    <div class="info">
      <h3><icon-document />{{ eventInfo.identification }}</h3>
      <h3><icon-calendar />{{ eventInfo.date.deadline | DateBR}}</h3>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { DateBR } from '@/components/primitives/helpers/filters'
import { IconCalendar, IconDocument } from '@/components/primitives/icons'

export default {
  name: 'EventInfo',
  components: {
    IconCalendar,
    IconDocument
  },
  data () {
    return {
      eventInfo: {
        client: {
          shortName: ''
        },
        identification: '',
        date: {
          deadline: ''
        }
      }
    }
  },
  filters: {
    DateBR
  },
  computed: {
    ...mapGetters({
      getEventInfo: 'Events/GET_EVENT_DETAILS'
    })
  },
  watch: {
    getEventInfo (pValue) {
      this.eventInfo = pValue
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-association/components/event-info/EventInfo.vue